import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EUnreadMessagesCountActionTypes {
  Set = 'unreadMessagesCount/set',
}

export type TUnreadMessagesCountActions = ITypedReduxAction<EUnreadMessagesCountActionTypes.Set, number>;
